import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';

class OrnamentGiftBox extends Component {
  async addBox() {
    if (this.pending) return;
    this.pending = true;
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    button.disabled = true;
    this.setAttribute('aria-busy', 'true');
    status.textContent = this.dataset.pending;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))];
    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.dataset.variant), quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        this.pending = false;
        button.disabled = false;
        status.textContent = typeof data.description === 'string' ? data.description : this.dataset.error;
        return;
      }
      status.textContent = this.dataset.success;
      this.dispatchEvent(new CartAddEvent({}, this.dataset.variant, { source: 'fp-ornament-gift-box', itemCount: 1, sections: data.sections }));
    } catch {
      // An uncertain response must not invite duplicate paid additions. The cart remains the authority.
      status.textContent = this.dataset.error;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('fp-ornament-gift-box')) customElements.define('fp-ornament-gift-box', OrnamentGiftBox);
